import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ComputedQuizScore } from "../../../interfaces";
import { StatusChip, StatusChipProps } from "./StatusChip";

interface StatusCardProps {
  status: StatusChipProps;
  children: any;
  buttons?: any;
  fillVertical?: boolean;
  gradedQuizScores?: ComputedQuizScore | null;
}

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "8px",
    position: "relative",
    border: `2px solid ${theme.palette.neutral.main}`,
    backgroundColor: "#FFF",
  },
  headerContent: {
    padding: "24px",
    borderBottom: `2px solid ${theme.palette.neutral.main}`,
  },
  content: {
    padding: "24px",
    flexGrow: 1,
  },
  buttons: {
    flexShrink: 0,
    padding: "8px",
    paddingTop: "0px",
  },
  status: {
    position: "absolute",
    right: "24px",
    top: "-2px",
  },
}));

export const StatusCard = (props: StatusCardProps) => {
  const classes = useStyles();

  return (
    <Stack
      direction="column"
      className={classes.root}
      height="100%"
      width="100%"
      sx={{ minHeight: props.fillVertical ? "100%" : undefined }}>
      {props.gradedQuizScores && props.gradedQuizScores.display_as === "points" && (
        <Box className={classes.headerContent}>
          <Box
            component="h2"
            sx={{
              marginTop: "0px",
              marginBottom: "0px",
              display: "flex",
              flexDirection: "column",
            }}>
            <Tooltip
              placement="bottom-start"
              arrow
              title="This is your total score for all graded quizzes in this module. It's based on your combined accuracy across activities.">
              <Typography
                component="span"
                variant="body1"
                lineHeight="24px"
                fontWeight={500}
                fontSize={16}
                color="#005685"
                sx={{
                  paddingX: "4px",
                  marginBottom: "16px",
                  backgroundColor: "#E0F4FF",
                  borderRadius: "4px",
                  marginRight: "auto",
                }}>
                <i className="fa-solid fa-star"></i>
                <Box
                  sx={{ marginLeft: "8px" }}
                  component="span"
                  textTransform="uppercase">
                  Module Grade
                </Box>
              </Typography>
            </Tooltip>
            <Typography
              component="span"
              variant="h2"
              lineHeight="26px"
              fontWeight={700}
              fontSize={40}
              sx={{ marginBottom: "8px" }}>
              {`${props.gradedQuizScores.points}/${props.gradedQuizScores.max_points}`}
            </Typography>
            <Typography
              component="span"
              variant="h2"
              lineHeight="26px"
              fontSize={16}
              fontWeight={600}
              sx={{ display: "block" }}>
              Points
            </Typography>
          </Box>
        </Box>
      )}
      <Box className={classes.content}>
        <Box className={classes.status}>
          <StatusChip {...props.status} />
        </Box>
        {props.children}
      </Box>
      {props.buttons && <Box className={classes.buttons}>{props.buttons}</Box>}
    </Stack>
  );
};
